"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorScheme = exports.ThemeProvider = exports.ThemeContext = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles/");
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const theme_1 = require("./theme");
exports.ThemeContext = react_1.default.createContext({
    colorScheme: "light",
    setColorScheme: () => {
        throw `Context provider not available`;
    },
});
exports.ThemeProvider = ({ children }) => {
    const savedColorScheme = react_1.useRef(typeof window !== "undefined" && localStorage.getItem("ThemeProvider:savedColorScheme"));
    const mediaColorScheme = useMediaQuery_1.default("(prefers-color-scheme: dark)") ? "dark" : "light";
    const [colorScheme, setColorSchemeState] = react_1.useState(savedColorScheme.current || mediaColorScheme);
    const setColorScheme = react_1.useCallback((colorScheme) => {
        setColorSchemeState(colorScheme);
        localStorage.setItem("ThemeProvider:savedColorScheme", colorScheme);
    }, []);
    const theme = colorScheme === "dark" ? theme_1.dark : theme_1.light;
    return (react_1.default.createElement(exports.ThemeContext.Provider, { value: { colorScheme, setColorScheme } },
        react_1.default.createElement(styles_1.ThemeProvider, { theme: theme }, children)));
};
exports.ThemeProvider.propTypes = {
    children: prop_types_1.default.node.isRequired,
};
exports.useColorScheme = () => react_1.useContext(exports.ThemeContext);
//# sourceMappingURL=ThemeProvider.js.map